import { createNamespacedHelpers } from "vuex-composition-helpers";
const {
  useActions,
  useGetters,
  useMutations,
  useState
} = createNamespacedHelpers("ApplicationsListStore");
export const useApplicationListStoreActions = useActions;
export const useApplicationListStoreGetters = useGetters;
export const useApplicationListStoreMutations = useMutations;
export const useApplicationListStoreState = useState;